import React from 'react';
import styled from 'styled-components/macro';
import coberturas from '../../../../data/coberturas.json';
import planosDit from '../../../../data/planosDit.json';

const CustomTable = styled.table`
  margin: 16px;
  width: 100vh;

  thead th {
    background-color: #00A89C80;
    color: #FFFFFF;
  }

  td {
    text-align: center;
    vertical-align: middle;
    padding: 5px;
  }

  tr {
    border-bottom: 1px solid #E4E5E7;
  }
`;

export default function TabelaPlanos({
  seguroSelecionado,
}) {
  const adicionarRegistros = () => {
    if (seguroSelecionado.id === 'vida') {
      return coberturas;
    }
    return planosDit;
  };

  const gerarTitulo = () => {
    if (seguroSelecionado.id === 'vida') {
      return 'Detalhes - Planos Sompo';
    }
    return 'DIT - Planos disponíveis para contratação';
  };

  const gerarColunas = () => {
    let colunas;
    if (seguroSelecionado.id === 'vida') {
      colunas = ['Coberturas Complementares'];
    } else {
      colunas = [
        'Plano',
        'Reembolso diário',
        'Morte Acidental',
        'Invalidez',
        'Custo Mensal',
      ];
    }
    return colunas.map((coluna) => (
      <th key={coluna} colSpan={colunas.length === 1 ? '100%' : ''}>
        {coluna}
      </th>
    ));
  };

  const gerarLinhas = () => adicionarRegistros().map((item) => {
    const colunas = Object.keys(adicionarRegistros()[0]);
    const celulas = colunas
      .filter((col) => col !== 'id')
      .map((colData) => <td key={colData}>{item[colData]}</td>);
    return <tr key={item.id}>{celulas}</tr>;
  });

  return (
    <>
      <h1>{gerarTitulo()}</h1>
      <CustomTable>
        <thead>
          <tr>
            {gerarColunas()}
          </tr>
        </thead>
        <tbody>
          {gerarLinhas()}
        </tbody>
      </CustomTable>
    </>
  );
}
